module.exports = __webpack_public_path__ + "img/mastermind-white-logo.bd860071.svg";